import type { LandingTextValue } from "@/lib/landing/puck/styled-text";

export type LandingPartnerItem = {
  /** Название (доступность + подпись при наведении). */
  title: LandingTextValue;
  /** Сайт — всегда новая вкладка. */
  href: string;
  /** Логотип S3. */
  logoUrl?: string;
};

export type LandingPartnersDefaults = {
  sectionId: string;
  title: LandingTextValue;
  subtitle: LandingTextValue;
  backgroundImageUrl: string;
  backgroundColor: string;
  /** marquee — бегущая лента; row — статичный ряд. */
  layout: "marquee" | "row";
  items: LandingPartnerItem[];
};

export const DEFAULT_PARTNERS_ITEMS: LandingPartnerItem[] = [
  {
    title: "Торгово-промышленная палата г.Пенза",
    href: "",
    logoUrl: "",
  },
  {
    title: "Фонд поддержки предпринимателей «Мой бизнес»",
    href: "",
    logoUrl: "",
  },
  {
    title: "ГКУ Пензенское региональное объединение бизнес-инкубаторов",
    href: "",
    logoUrl: "",
  },
];

export const DEFAULT_PARTNERS: LandingPartnersDefaults = {
  sectionId: "partners",
  title: "Нам доверяют и поддерживают развитие бизнеса",
  subtitle:
    "Наши партнёры помогают развивать культуру аналитики и делать инструменты исследования рынка доступнее для бизнеса.",
  backgroundImageUrl: "",
  backgroundColor: "",
  layout: "marquee",
  items: [...DEFAULT_PARTNERS_ITEMS],
};
